import { useEffect, useState } from "react";
import { Star, Loader2 } from "lucide-react";
import { adminApi } from "@/lib/api";
import { QrCard } from "@/components/admin/MenuQrCard";
import { HowItWorks } from "@/components/HowItWorks";

export const Stars = ({ n }) => (
  <span className="inline-flex" aria-label={`${n} stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`w-4 h-4 ${i <= n ? "fill-[var(--trio-accent)] text-[var(--trio-accent)]" : "text-[var(--trio-border)]"}`} />
    ))}
  </span>
);

export const ReviewList = ({ reviews, showStaff = false }) => (
  <ul className="divide-y divide-[var(--trio-border)] border border-[var(--trio-border)] bg-[var(--trio-surface)]">
    {reviews.map((r) => (
      <li key={r.id} data-testid={`review-${r.id}`} className="p-4">
        <div className="flex items-center justify-between gap-2">
          <Stars n={r.rating} />
          <span className="text-[11px] text-[var(--trio-muted)]">{new Date(r.created_at).toLocaleDateString()}</span>
        </div>
        {r.comment && <p className="text-sm mt-2">{r.comment}</p>}
        <div className="text-xs text-[var(--trio-muted)] mt-1">
          — {r.name || "Guest"}{showStaff ? ` · for ${r.staff_name}` : ""}
        </div>
      </li>
    ))}
  </ul>
);

export const MyReviews = () => {
  const [data, setData] = useState(null);
  const [code, setCode] = useState(null);

  useEffect(() => {
    adminApi.get("/staff/my-reviews").then(({ data }) => setData(data)).catch(() => setData({ reviews: [], count: 0 }));
    adminApi.get("/staff/referral").then(({ data }) => setCode(data.referral_code)).catch(() => {});
  }, []);

  if (!data) return <Loader2 className="w-5 h-5 animate-spin" />;

  return (
    <section data-testid="my-reviews" className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <h2 className="font-display uppercase text-3xl tracking-tight">My Reviews</h2>
        <div data-testid="my-reviews-summary" className="text-right">
          <div className="font-display text-4xl text-[var(--trio-primary)]">{data.average ?? "—"}</div>
          <div className="text-[10px] uppercase tracking-widest text-[var(--trio-muted)]">{data.count} reviews · {data.five_stars || 0} five-star</div>
        </div>
      </div>
      {code && (
        <QrCard
          url={`${window.location.origin}/review/${code}`}
          label="Rate Me QR"
          title="Let Guests Rate You"
          description="Show this at the end of service or put it on the check presenter. Every 5-star review = 1 contest point."
          printHeading="How Was Your Server?"
          filename={`trio-review-${code}.png`}
          testid="my-review-qr"
        />
      )}
      <HowItWorks topics={["reviews", "contests"]} />
      {data.reviews.length ? <ReviewList reviews={data.reviews} /> : <p className="text-sm text-[var(--trio-muted)]">No reviews yet. Share your Rate Me QR.</p>}
    </section>
  );
};
